import { NavLink } from 'react-router-dom';
import styled, { css } from 'styled-components';
import { colors, MediaQuery } from '../../theme/style-helpers';
import { P } from '../../theme/typographySitecore';

export const NavigationContainer = styled.header`
    padding: 0 20px;

   ${MediaQuery.xLarge`
        position: sticky;
        top: 0;
        width: 100%;
        height: max-content;
        background-color: ${colors.WHITE};
        display: flex;
        justify-content: center;
        padding: 0 60px;
        z-index: 200;
        border-bottom: 1px solid #D9D9D6;
    `};
`;

export const NavigationInner = styled.nav`
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: space-between;
    padding: 8px 0;
    
    ${MediaQuery.xLarge(css`
        padding: 0;
        max-width: 1320px;
    `)};
`;

export const BreadcrumbMain = styled.div`
    display: flex;
    justify-content: center;
    padding: 20px 20px 56px;
    width: 100%;

    ${MediaQuery.xLarge(css`
        padding: 20px 60px 56px;
    `)};

    &.no-padding {
        padding-left: 0;
        padding-bottom: 6px;
    }

    &.no-padding-left {
        padding-left: 0;
    }
`;

export const Breadcrumb = styled.div`
    max-width: 1320px;
    width: 100%;
    
    p {
        font-family: Montserrat;
        font-style: normal;
        font-weight: 500;
        font-size: 10px;
        line-height: 14px;
    };
`;

export const BreadcrumbContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
`;

export const BreadcrumbItem = styled.div`
    p {
        margin: 0;
        font-size: 1.3rem;
    }

    svg {
        width: 18px;
    }
`;

export const NavigationMenu = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
`;

export const UserBox = styled.button`
    background: none;
    color: inherit;
    border: none;
    padding: 0;
    font: inherit;
    cursor: pointer;
    outline: inherit;
    display: grid;
    grid-template-columns: repeat(2, max-content);
    column-gap: 8px;
    align-items: center;
    
    object {
        pointer-events: none;
    }

    p {
        margin: 0;
        font-weight: 500;
        font-size: 14px;
        color: ${colors.BLACK};
    }

    &:hover p {
        text-decoration: underline;
    }

    &:focus {
        -moz-outline-style: none;
        outline: none;
    }
`;

export const LangBox = styled.div`
    display: grid;
    grid-template-columns: max-content 1px max-content;
    column-gap: 12px;
    align-items: center;
    height: 100%;

    span {
        background-color: ${colors.DARK_GREY};
        height: 12px;
        width: 1px;
    }
`;

export const LangLink = styled(NavLink)`
    color: ${colors.DARK_GREY};
    font-size: 14px;
    font-weight: 500;

    &.active {
        color: ${colors.BLACK};
    }
    
    &:hover {
        cursor: pointer;
        color: ${colors.BLACK};
        text-decoration: none;
    }
`;

export const Icon = styled.img`
  height: 20px;
  width: 20px;
`;

export const DivisionLabel = styled(P)`
  text-align: center;
  margin: 0;
  margin-left: 0px;
  font-size: 8px;
  
  ${MediaQuery.small`  
    margin-left: 8px;
    font-size: 14px;
  `}
`;

export const MenuContainer = styled.div`
    .nav-menu {
        display: flex;
        width: 100%;
        max-width: 1204px;
        margin: auto;
        list-style: none;
        padding: 0;
        flex-direction: column;

        ${MediaQuery.small`
            flex-direction: row;
        `}

        .nav-item {
            font-style: normal;
            font-weight: 500;
            font-size: 1.2rem;
            line-height: 1.6rem;
            padding: 1rem 1.5rem;

            ${MediaQuery.small`
                padding: 2rem 3rem;
            `}

            .nav-link {
                color: ${colors.BLACK};
            }
        }
    }
`;

export const MenuIcon = styled.img`

`;

export const Logo = styled.img`
    max-width: 40px;

    ${MediaQuery.small`
        max-width: 60px;
    `}
`;

export const LogoContainer = styled.a`
    margin-right: auto;

    object {
        pointer-events: none;
        height: 40px;
        width: auto;
    }

    ${MediaQuery.xLarge(css`
        padding: 16px 0;
        margin-right: 0;

        object {
            height: auto;
        }
    `)};
`;

export const UtilityBox = styled.ul`
    padding-inline-start: 0;
    list-style-type: none;
    margin: 0;
    display: flex;
    justify-content: space-between;
    padding-bottom: 40px;

    ${MediaQuery.small(css`
        display: grid;
        column-gap: 56px;
        grid-auto-flow: column;
        grid-auto-columns: max-content;
    `)};

    ${MediaQuery.xLarge(css`
        padding: 0;
        display: grid;
        grid-auto-flow: column;
        grid-auto-columns: max-content;
        column-gap: 32px;
        align-items: center;
        align-content: center;
        height: 20px;
    `)};
`;

export const ChatBox = styled.button`
    background: none;
    color: inherit;
    border: none;
    padding: 0;
    font: inherit;
    cursor: pointer;
    outline: inherit;
    display: grid;
    grid-template-columns: repeat(2, max-content);
    column-gap: 8px;
    align-items: center;

    object {
        pointer-events: none;
    }

    p {
        margin: 0;
        font-weight: 500;
        font-size: 14px;
        color: ${colors.BLACK};
    }

    &:hover p {
        text-decoration: underline;
    }

    &:focus {
        -moz-outline-style: none;
        outline: none;
    }
`;

export const MenuBox = styled.button`
    * {
        pointer-events: none;
    }

    width: 20px;
    margin: 0;
    padding: 0;
    border: none;
    display: flex;
    background-color: transparent;

    &:hover {
        cursor: pointer;
    }

    ${MediaQuery.xLarge(css`
        display: none;
    `)};
`;

export const Overlay = styled.div`
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    z-index: 1;
    background-color: rgba(0, 0, 0, 0.5);
    position: fixed;
    backdrop-filter: blur(2px);
    display: ${({ $isPanelOpen }) => ($isPanelOpen ? 'flex' : 'none')};

    ${MediaQuery.xLarge(css`
        display: none;
    `)};
`;

export const Panel = styled.div`
    width: 100%;
    display: ${({ $isOpen }) => ($isOpen ? 'grid' : 'none')};
    position: fixed;
    overflow-y: auto;
    right: 0;
    top: 0;
    bottom: 0;
    background-color: ${colors.WHITE};
    padding: 8px 20px;
    grid-auto-flow: row;
    grid-auto-rows: max-content;
    row-gap: 40px;
    z-index: 4;

    ${MediaQuery.small(css`
        width: 466px;
    `)}

    ${MediaQuery.xLarge(css`
        overflow-y: unset;
        display: grid;
        position: unset;
        top: unset;
        right: unset;
        left: unset;
        bottom: unset;
        max-width: 1320px;
        width: 100%;
        grid-auto-flow: column;
        grid-template-columns: max-content auto max-content;
        padding: 0;
        align-items: center;
    `)};
`;

export const Header = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const CloseButtonContainer = styled.button`
    * {
        pointer-events: none;
    }

    display: flex;
    background-color: transparent;
    border: none;

    &:hover {
        cursor: pointer;
    }

    ${MediaQuery.xLarge(css`
        display: none;
    `)}
`;

export const MinimizedNavBar = styled.div`
    padding: 8px 20px;
    position: sticky;
    top: 0;
    width: 100%;
    background-color: ${colors.WHITE};
    display: flex;
    justify-content: space-between;
    align-items: center;
    z-index: 2;
    border-bottom: 1px solid #D9D9D6;

   ${MediaQuery.xLarge`
        display: none;
    `};
`;
